import { SiteMapMapper } from '@mappers/SiteMapMapper';
import { AppComponents } from '@configuration/AppComponents';
import { IPromiseCache, cachedWrapper } from '@utilities/MemoryCachingHelpers';
import { IPageRoute, SiteMap, SiteMarker } from '@models/SiteMap';
import { AppModule } from '../configuration/AppModule';

export class SitemapDefinition {
    private static _sitemapDefinitionCache: IPromiseCache<SiteMap> = {};
    private static _currentSitemap: SiteMap;

    public static async getAsync(): Promise<SiteMap> {
        return cachedWrapper("SITEMAP", async () => {
            const appModule = AppModule.get();
            const siteMapRoot = await SiteMapMapper.parseAsync(appModule.siteMapXml);
            const sitemap = new SiteMap(siteMapRoot);
            await sitemap.loadStaticPages();
            return sitemap;
        }, this._sitemapDefinitionCache);
    }
    public static getCurrentSiteMap(): SiteMap {
        if (!this._currentSitemap) {
            throw new Error('Current sitemap is undefined, have you called loadCurrentSitemapAsync?');
        }
        return this._currentSitemap;
    }
    public static async loadCurrentSitemapAsync(): Promise<void> {
        this._currentSitemap = await this.getAsync();
    }

    public static getWellKnownPage(marker: SiteMarker): string {
        return this._currentSitemap.getWellKnownPage(marker);
    }

    public static getStaticPageRoutes(): IPageRoute[] {
        return this._currentSitemap.getStaticPageRoutes();
    }
}